import React, { useEffect, useState, useMemo } from "react";
import './ChecklistDiario.scss'
import Filtros from "./partes/Filtros";
import Indicadores from "./partes/Indicadores";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { getChecklistDiario } from "./integracion";
import { formateoBasico } from "../../../utilidades/formateos";
import { modalLoading, closeModalLoading } from "../../../components/atoms/ModalLoading/loadingModal";


const ChecklistDiario = ()=>
{
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [filtroIndicadores, setFiltroIndicadores] = useState('total')
    const [checklistData, setChecklistData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [expandedKeys, setExpandedKeys] = useState({});
    const [loading, setLoading] = useState(false);

    const expandAll = () => {
        const keys = {};
        checklistData.forEach(node => { keys[node.key] = true; });
        setExpandedKeys(keys);
    };

    const collapseAll = () => setExpandedKeys({});

    useEffect(()=>{
        if(!fechaInicio || !fechaFin) return;
        const params = {
            fechaInicio: formateoBasico(fechaInicio),
            fechaFin: formateoBasico(fechaFin)
        }
        setLoading(true);
        modalLoading('Cargando checklist...');
        getChecklistDiario(params).then((res)=>{
            setChecklistData(res)
        }).finally(() => {
            setLoading(false);
            closeModalLoading();
        });
    },[fechaFin, fechaInicio])

    const totalCount = checklistData.length;

    const conProblemasCount = useMemo(() =>
        checklistData.filter(node => node.children?.some(c => c.data.VALOR === 0)).length
    , [checklistData]);

    const dataFiltrada = useMemo(() => {
        let data = checklistData;

        if (filtroIndicadores === 'conProblemas') {
            data = data
                .filter(node => node.children?.some(c => c.data.VALOR === 0))
                .map(node => ({
                    ...node,
                    children: node.children.filter(c => c.data.VALOR === 0)
                }));
        }

        if (globalFilter) {
            const search = globalFilter.toLowerCase();
            data = data.filter(node => {
                const parentMatch = Object.values(node.data).some(v =>
                    String(v).toLowerCase().includes(search)
                );
                const childMatch = node.children?.some(c =>
                    Object.values(c.data).some(v => String(v).toLowerCase().includes(search))
                );
                return parentMatch || childMatch;
            });
        }

        return data;
    }, [checklistData, filtroIndicadores, globalFilter]);

    const conceptoTemplate = (node) => {
        if (node.children) {
            // Nodo padre: mostrar fecha
            return <strong>{node.data.FECHA}</strong>;
        }
        return <span>{node.data.CONCEPTO}</span>;
    };

    const operadorTemplate = (node) => {
        if (node.children) {
            return <span>{node.data.OPERADOR}</span>;
        }
        // Nodo hijo: mostrar ícono según VALOR
        if (node.data.VALOR === 1) {
            return <i className="pi pi-check-circle" style={{ color: '#22c55e', fontSize: '1.1rem' }}></i>;
        }
        return <i className="pi pi-times-circle" style={{ color: '#ef4444', fontSize: '1.1rem' }}></i>;
    };

    const unidadTemplate = (node) => {
        if (node.children) {
            return <span>{node.data.ID_UNIDAD}</span>;
        }
        return null;
    };

    const idChecklistTemplate = (node) => {
        if (node.children) {
            return <span>{node.data.ID_CHECKLIST}</span>;
        }
        return null;
    };

    const fotoTemplate = (node) => {
        if (node.children) {
            const tieneFotos = node.children.some(c => c.data.FOTO);
            if (!tieneFotos) return null;
            return <i className="pi pi-camera" style={{ color: '#0078D4', fontSize: '1rem' }} title="Tiene evidencia fotográfica"></i>;
        }
        if (!node.data.FOTO) return null;
        const url = `https://repo.sumaenlinea.mx/evidencias_checklist/${node.data.FOTO}`;
        return (
            <a href={url} target="_blank" rel="noreferrer">
                <img src={url} alt="evidencia" style={{ width: '48px', height: '48px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer' }} />
            </a>
        );
    };

    return(
        <div className="ChecklistDiario">
          <Filtros
            fechaInicio={fechaInicio}
            setFechaInicio={setFechaInicio}
            fechaFin={fechaFin}
            setFechaFin={setFechaFin}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            expandAll={expandAll}
            collapseAll={collapseAll}
          />
          <Indicadores setFiltroIndicadores={setFiltroIndicadores} totalCount={totalCount} conProblemasCount={conProblemasCount} />
          <TreeTable value={dataFiltrada} paginator rows={9} scrollable scrollHeight="calc(100vh - 304px)" responsiveLayout="scroll" expandedKeys={expandedKeys} onToggle={e => setExpandedKeys(e.value)} style={{ fontSize: 'small' }} rowClassName={node => ({ 'fila-hijo': !node.children })}>
              <Column header="Fecha / Concepto" body={conceptoTemplate} expander style={{ width: '35%' }}></Column>
              <Column header="Operador / Estado" body={operadorTemplate} style={{ width: '35%' }}></Column>
              <Column header="ID Checklist" body={idChecklistTemplate} style={{ width: '15%' }}></Column>
              <Column header="ID Unidad" body={unidadTemplate} style={{ width: '10%' }}></Column>
              <Column header="Foto" body={fotoTemplate} style={{ width: '10%' }}></Column>
          </TreeTable>
          {loading && <div className="loading-overlay">Cargando...</div>}
        </div>
    )
}
export default ChecklistDiario